import { useEffect } from 'react'
import { CLARIFICATION_SUBMITTED_EVENT } from '@/features/chat/clarifications/clarificationChannel'
import { markClarificationSubmitted } from '@/features/chat/clarifications/markClarificationSubmitted'

/**
 * Turn an accepted submission into a normal assistant turn.
 *
 * The response is already open, so the send path is handed `openStream` and
 * skips its own POST. Everything after that — the user bubble, the pending
 * assistant row, the timeline, the in-flight guard — is the ordinary path, which
 * is the whole reason for routing back through `handleSendMessage` rather than
 * draining the stream here.
 */
export function useClarificationStream({ displayThreadId, setMessagesByThreadId, handleSendMessage }) {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const onSubmitted = (event) => {
      const { content, response, assistantMessageId, answers } = event.detail ?? {}
      if (!content || !response) return
      if (displayThreadId) {
        setMessagesByThreadId((prev) =>
          markClarificationSubmitted(prev, { tid: displayThreadId, assistantMessageId, answers }),
        )
      }
      handleSendMessage({ text: content, files: [], openStream: () => response })
    }
    window.addEventListener(CLARIFICATION_SUBMITTED_EVENT, onSubmitted)
    return () => window.removeEventListener(CLARIFICATION_SUBMITTED_EVENT, onSubmitted)
  }, [displayThreadId, setMessagesByThreadId, handleSendMessage])
}
